/**
 * CS-1628 — the chat-kind predicate, in `core` so the ingestion gate can use it.
 *
 * This test already existed, in `packages/mcp/src/onboarding-dm-gate.ts`, wired
 * only into the onboarding command (ENG-6646). The customer ask was for the
 * same test one layer down, at ingestion. It lives here now and the mcp module
 * re-exports it rather than keeping a second copy: two implementations of "is
 * this a group" is precisely how the two of them drift apart, and the one that
 * drifts is a security control.
 */

/**
 * Telegram: a 1:1 chat has `chat.type === 'private'`. `group`, `supergroup` and
 * `channel` are not. A missing or unknown type is NOT private — fail closed, so
 * an inbound whose shape we do not recognise is treated as the more restricted
 * case rather than waved through.
 */
export function isTelegramPrivateChat(chatType: string | null | undefined): boolean {
  return chatType === 'private';
}
